
class From {
	constructor(form, props, rules){
		this.form = form;
		this.props = props;
		this.rules = rules;
	}
	//规则验证
	validate(callback, isOnly = true){
		if(!callback) return;
		const formItems = this.getValidateFields();
		if(formItems.length == 0){
			callback(false);
		}
		let valid = true;
		let messages = {};
		let count = 0;
		let isCallback = false;
		formItems.forEach(formItem => {
			if(isCallback) return;
			formItem.validate(message=>{
				if(message){
					valid = false;
					if(isOnly){
						callback(valid, message, formItem.prop);
						isCallback = true;
					}else{
						messages[formItem.prop] = message;
					}
				}
				if (!isCallback && ++count === formItems.length) {
					callback(valid, messages);
				}
			})
		});
	}
	getValidateFields(){
		let form = this.form,
			props = this.props,
			rules = this.rules;
		return props.map(prop=>{
			return {
				prop,
				validate(callback){
					let validator = rules[prop];
					if(!validator || !(validator instanceof Function)){
						callback();
						return;
					}
					let value = form[prop];
					let isValidatorCallback = false;
					validator(value, message=>{
						if(isValidatorCallback) return;
						isValidatorCallback = true;
					    if(message){
					        callback(message);
					    }else{
					        callback();
					    }
					})
				}
			}
		})
	}
}
export default From;